<div class="quick-selector">
    <div class="quick-selector__inner">

        <shared-drop-down (onToggle)="onDropdownToggle($event)" (onSelected)="onDropdownSelected($event)"
            [options]="options" [projection]="projection" [projectionStyle]="projectionStyle" [selected]="selected"
            [position]="position" [theme]="theme" [size]="size">

            <button class="quick-selector__btn">
                <span class="quick-selector__btn-content">

                    <span class="quick-selector__value">
                        {{selected?.Name || defaultLabel}}
                    </span>

                    <shared-icon icon="down" class="quick-selector__icon"></shared-icon>

                </span>
            </button>


        </shared-drop-down>

    </div>
</div>